<template>
  <div id="carouselExample4" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner bg-dark" style="height: 350px">
      <div v-show="activeSlide == t.id" v-for="(t, i) in tasks" :key="i">
        <div class="carousel-caption d-none d-md-block">
          <h5 class="text-white">
            <div class="avatar avatar-xxl" style="margin: 0 auto 30px">
              <img
                class="rounded-circle"
                :src="`${t.defaultAttachmentUrl}?w=100&h=100&mode=crop`"
              />
            </div>
            <div>
              {{ t.task }}
            </div>
          </h5>
          <p class="tx-14">{{ t.f1 }}</p>
        </div>
      </div>
    </div>
    <a @click="nextOrPrev(-1)" class="carousel-control-prev" role="button">
      <span class="carousel-control-prev-icon" aria-hidden="true"
        ><feather type="chevron-left"></feather
      ></span>
      <span class="sr-only">Previous</span>
    </a>
    <a @click="nextOrPrev(1)" class="carousel-control-next" role="button">
      <span class="carousel-control-next-icon" aria-hidden="true"
        ><feather type="chevron-right"></feather
      ></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      activeSlide: 0,
      tasks: []
    };
  },
  mounted() {
    this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    loadTasks(typeId) {
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 3,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
          if (this.tasks.length > 0) {
            this.activeSlide = this.tasks[0].id;
          }
        }
      });
    },
    nextOrPrev() {}
  }
};
</script>

<style></style>
